import React, { useState } from "react";
import {
  Form,
  Typography,
  Col,
  Row,
  InputNumber,
  Input,
  TimePicker,
  Tooltip,
} from "antd";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const format = "hh:mm A";
const getDisabledTime = () => {
  const now = dayjs();

  return {
    disabledHours: () => {
      const hours = [];
      for (let i = now.hour() + 1; i < 24; i++) {
        hours.push(i);
      }
      return hours;
    },

    disabledMinutes: (selectedHour) => {
      if (selectedHour === now.hour()) {
        const minutes = [];
        for (let i = now.minute() + 1; i < 60; i++) {
          minutes.push(i);
        }
        return minutes;
      }
      return [];
    },

    disabledSeconds: () => [],
  };
};
const AiIoAddForm = ({ hourlyIntake, hourlyOutput }) => {
  const formItems = [
    { name: "Oral/Tube", value: "oral_tube_intake" },
    { name: "GI Losses", value: "gi_losses" },
    { name: "Flush", value: "flush" },
    { name: "UO", value: "uo" },
    { name: "IV", value: "iv_fluids" },
    { name: "Drain", value: "drain" },
  ];
  return (
    <div>
      <Form.Item
        label="Time"
        name="process_time"
        rules={[{ required: true, message: "Please Select time" }]}
      >
        <TimePicker
          inputReadOnly
          format={format}
          needConfirm={false}
          disabledTime={getDisabledTime}
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Row gutter={[12, 0]} className="nurse-monitoring-form-grid">
        {formItems?.map((item) => (
          <Col xs={24} sm={12} key={item.value}>
            <Form.Item
              key={item.value}
              label={item.name}
              name={item.value}
              rules={[
                { type: "number", message: "Please enter a valid number" },
              ]}
            >
              <InputNumber addonAfter="ml" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        ))}

        <Col xs={24}>
          <Row align="middle" gutter={24}>
            <Col xs={24} md={12}>
              {" "}
              <Typography.Text>
                Hourly Intake: {hourlyIntake} ml{" "}
                <Tooltip
                  title={
                    <span style={{ fontSize: "10px" }}>
                      Oral/Tube + Flush + IV fluids
                    </span>
                  }
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </Typography.Text>
            </Col>

            <Col xs={24} md={12}>
              {" "}
              <Typography.Text>
                Hourly Output: {hourlyOutput} ml{" "}
                <Tooltip
                  title={
                    <span style={{ fontSize: "10px" }}>
                      GI Losses + UO + Drain
                    </span>
                  }
                >
                  <InfoCircleOutlined />
                </Tooltip>
              </Typography.Text>
            </Col>
          </Row>
          <div style={{ marginTop: "10px" }}>
            <Form.Item label="Remarks :" name="additional_info">
              <Input.TextArea />
            </Form.Item>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AiIoAddForm;
